import React from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-gray-50 text-gray-700">
      <div className="max-w-7xl mx-auto px-4 py-12">
        {/* Newsletter / Contact */}
        <div className="mb-12 text-center flex flex-col md:flex-row justify-center gap-6 md:gap-16 items-center bg-white p-8 rounded-lg">
          <h4 className="text-xl font-semibold">Laissez-nous un message</h4>
          <a
            href="mailto:contact@datagreffe.ci"
            className="flex items-center gap-3 bg-green-600 text-white px-8 py-3 rounded-lg hover:bg-green-700 transition"
          >
            <Mail className="h-5 w-5" />
            contact@datagreffe.ci
          </a>
        </div>

        {/* Footer main sections */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Logo & Description */}
          <div className="text-center md:text-left">
            <a href="#" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/images/logo-recoov.png"
                alt="Logo Datagreffe"
                className="mx-auto md:mx-0 w-24 mb-4"
              />
            </a>
            <p>
              Accédez à toutes les informations légales, juridiques et financières
              sur les entreprises ivoiriennes en quelques clics.
            </p>
          </div>

          {/* Services */}
          <div>
            <h5 className="font-medium mb-3">Services</h5>
            <ul className="space-y-2">
              <li>
                <a href="/services" className="hover:text-green-600">
                  Annonces légales
                </a>
              </li>
              <li>
                <a href="/services" className="hover:text-green-600">
                  Formalités
                </a>
              </li>
              <li>
                <a href="/services" className="hover:text-green-600">
                  Documents légaux
                </a>
              </li>
            </ul>
          </div>

          {/* À propos */}
          <div>
            <h5 className="font-medium mb-3">À propos</h5>
            <ul className="space-y-2">
              <li>
                <a href="/about" className="hover:text-green-600">
                  Notre mission
                </a>
              </li>
              <li>
                <a href="/contact" className="hover:text-green-600">
                  Contact
                </a>
              </li>
              <li>
                <a href="/recrutement" className="hover:text-green-600">
                  Recrutement
                </a>
              </li>
            </ul>
          </div>

          {/* Informations */}
          <div>
            <h5 className="font-medium mb-3">Informations</h5>
            <ul className="space-y-2">
              <li>
                <a href="/faq" className="hover:text-green-600">
                  FAQ
                </a>
              </li>
              <li>
                <a href="/mentions-legales" className="hover:text-green-600">
                  Mentions légales
                </a>
              </li>
              <li>
                <a href="/privacy" className="hover:text-green-600">
                  Données personnelles
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom / Socials */}
        <div className="border-t border-gray-200 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-500 mb-4 md:mb-0">
            © {new Date().getFullYear()} Datagreffe. Tous droits réservés.
          </p>
          <div className="flex space-x-4">
            {/* LinkedIn */}
            <Link
              to="#"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-gray-600"
              aria-label="LinkedIn"
            >
              <svg
                className="h-6 w-6"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
              </svg>
            </Link>
            {/* Facebook */}
            <Link
              to="#"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-gray-600"
              aria-label="Facebook"
            >
              <svg
                className="h-6 w-6"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M22 12c0-5.523-4.477-10-10-10s-10 4.477-10 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54v-2.891h2.54v-2.203c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562v1.875h2.773l-.443 2.891h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
              </svg>
            </Link>
            {/* Twitter */}
            <Link
              to="#"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-gray-600"
              aria-label="Twitter"
            >
              <svg
                className="h-6 w-6"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;